// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { userSetupSettingsStyles } from "@awc/Overrides/Widgets/UserSetup/UserSetupSettings";
import { color } from "@awc/XDL/Utilities";
import HelpCircle from "@insite/mobius/Icons/HelpCircle";
import { css } from "styled-components";

userSetupSettingsStyles.title = {
    variant: "h5",
    css: css`
        padding-bottom: 14px;
        border-bottom: 1px solid ${color("common.border")};
        margin-top: 7px;
    `,
};

userSetupSettingsStyles.roleSelectHelpIcon = {
    src: HelpCircle,
    size: 16,
    css: css`
        margin-left: 5px;
        cursor: pointer;
        color: ${color("secondary")};
    `,
};

userSetupSettingsStyles.approverSelectTooltip = {
    iconProps: {
        css: css`
            margin-left: 5px;
            vertical-align: bottom;
        `,
    },
};

userSetupSettingsStyles.labelWrapper = {
    css: css`
        display: flex;
        align-items: start;
    `,
};

userSetupSettingsStyles.approverLabelWrapper = {
    css: css`
        display: flex;
        align-items: start;
    `,
};
